/* eslint-disable */
import React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles } from '@material-ui/core';
import { WbIcon } from '@workbench/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './IconNavigation.css';

const useStyles = makeStyles(() =>
    createStyles({
        content: {
            color: 'white',
            textAlign: 'center',
        },
    })
);

export default function IconNavigation(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Link to={props.link} style={{ textDecoration: 'none' }}>
            <div className="iconNavigationContainer">
                <button className="roundButtonStyle" aria-label="Hotspot info">
                    {/* Changed from <wb-icon> to the imported React wrapper <WbIcon> */}
                    <WbIcon className="iconStyle" name="bds/hotspot-active/24" />
                </button>

                <div className="tooltipWrapper no-mobile">
                    <Link to={props.link} style={{ color: 'white', textDecoration: 'none' }}>
            <span className="tooltipStyle no-mobile">
              {t(props.description)}
                <WbIcon className={clsx('tooltipIcon')} name="bds/chevron-right/24" />
            </span>
                    </Link>
                    <div className="tooltipArrow no-mobile"></div>
                </div>
            </div>
        </Link>
    );
}
